export function getClientHeight() {
  let winHeight = 0
  if (window.innerHeight) winHeight = window.innerHeight
  else if (document.body && document.body.clientHeight) {
    winHeight = document.body.clientHeight
  }
  return winHeight
}
/**
 * 验证类型
 */
export function createIS(type) {
  return function(params) {
    if (Object.prototype.toString.call(params) === '[object " + type + "]') {
      if (type === 'Number' && isNaN(params)) {
        return false
      } else {
        return true
      }
    } else {
      return false
    }
  }
}

// 设置cookie
export function setCookie(name, value, day) {
  var date = new Date()
  date.setDate(date.getDate() + day)
  document.cookie = name + '=' + value + ';expires=' + date
}
// 获取cookie
export function getCookie(name) {
  var reg = RegExp(name + '=([^;]+)')
  var arr = document.cookie.match(reg)
  if (arr) {
    return arr[1]
  } else {
    return ''
  }
}
// 删除cookie
export function clearCookie(name) {
  setCookie(name, null, -1)
}
